export default __webpack_public_path__ + "static/media/emailme.8a80ecd4.svg";